import { Controller } from "stimulus"

export default class extends Controller {
  hide() {
    var element = $(this.element)
    $.animateCSS(element, 'fadeOutUp faster', ()=>{ element.hide() })
  }
}
